/* eslint-disable no-param-reassign */
import * as types from './types'

export default {
  [types.MUT_SET_BREADCRUMB](state, breadcrumb) {
    state[types.STATE_BREADCRUMB] = breadcrumb
  },
}
